module.exports = __webpack_public_path__ + "static/media/twitter-letter-logo.86a8d3e3.svg";